/* eslint-disable */
import { useEffect, useState, useRef } from "react";
import "./styles.scss";

// Custom hook cho Intersection Observer
const useIntersectionObserver = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
        ...options,
      },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  return [ref, isIntersecting];
};

// Component FadeInSection
const FadeInSection = ({ children, delay = 0, direction = "up" }) => {
  const [ref, isVisible] = useIntersectionObserver();

  const getDirectionClass = () => {
    switch (direction) {
      case "up":
        return "fade-in-up";
      case "down":
        return "fade-in-down";
      case "left":
        return "fade-in-left";
      case "right":
        return "fade-in-right";
      default:
        return "fade-in";
    }
  };

  return (
    <div
      ref={ref}
      className={`fade-in-section ${isVisible ? "is-visible" : ""} ${getDirectionClass()}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default FadeInSection;
